import { Modal } from "@oysterhr/ui"
import { useAPIError } from "./useAPIError"

export const APIErrorNotification = () => {
  const { error, removeError } = useAPIError()

  return (
    error && (
      <Modal isOpen onRequestClose={removeError} data-testid="api-error-modal">
        <Modal.Header>Error</Modal.Header>
        <Modal.Content>{error.message && <p>{error.message}</p>}</Modal.Content>
      </Modal>
    )
  )
}
